module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_yoso-c9650ac8ffefb442e4810237c40aae86.jpg";